module.exports = __webpack_public_path__ + "img/process_medium@2x.b3cf2e55.jpg";